firebird.factory('videoMediaConstraintsService', [
    '$timeout',
    'logService',
    'helperService',
    'avDeviceService',
    'storageService',
    'videoFilterService',
    'videoGlobalService',
    function (
        $timeout,
        logService,
        helperService,
        avDeviceService,
        storageService,
        videoFilterService,
        videoGlobalService
    ) {
        var service = {
            initialize: initialize
        };

        var self, $scope;

        const logger = new LogServiceWrapper(logService, '[videoroomCtrl] videoMediaConstraintsService');

        return service;

        function initialize(selfParam) {
            self = selfParam;
            $scope = videoGlobalService.data.$scope;

            self.initMediaConstraints = initMediaConstraints;
            self.getMediaConstraints = getMediaConstraints;
            self.getConstraintDeviceId = getConstraintDeviceId;
            self.getMaxVideoResolution = getMaxVideoResolution;
            self.getMaxFrameRate = getMaxFrameRate;

            $scope.$on('start-virtual-background-stream', onStartVirtualBackgroundStream);
            $scope.$on('stop-virtual-background-stream', onStopVirtualBackgroundStream);

            self.reapplyPublishConstraints = reapplyPublishConstraints;
        }

        function initMediaConstraints() {
            // no initialization needed
        }

        // get the media constraint object for janus' getUserMedia in createOffer.
        // it injects the audio or video device id is configured in the app.
        function getMediaConstraints(type, is_screen) {
            var media = {};
            if (type == 'video' || type == 'video-change' || type == 'video-filter') {
                media = {
                    audioRecv: false,
                    videoRecv: false,
                    audioSend: false,
                    videoSend: true
                };
                if (type == 'video-change') {
                    media.replaceVideo = true;
                }
                if (type == 'video-filter') {
                    media = {};
                }

                media.video = {};

                var videoDevice = storageService.get('video-device');
                if (videoDevice) {
                    // put device ID in constraints object.
                    media.video.deviceId = self.getConstraintDeviceId(videoDevice);
                    self.selectedVideoInput = videoDevice;
                }

                var resolution = self.getMaxVideoResolution();
                var frameRate = self.getMaxFrameRate();
                if (type == 'video-filter') {
                    media.video.frameRate = frameRate;
                    media.video.width = resolution.width;
                    media.video.height = resolution.height;
                } else {
                    media.video.frameRate = {
                        min: Math.min(5, self.frameRate || 5),
                        max: frameRate,
                        ideal: frameRate
                    };

                    media.video.width = {
                        min: Math.min(320, resolution.width || 320),
                        max: !self.simulcastToggleState.restricted ? resolution.width : Math.max(640, resolution.width),
                        ideal: resolution.width
                    };

                    media.video.height = {
                        min: Math.min(180, resolution.height || 180),
                        max: !self.simulcastToggleState.restricted
                            ? resolution.height
                            : Math.max(360, resolution.height),
                        ideal: resolution.height
                    };
                }

                media.video.aspectRatio = resolution.width / resolution.height;

                // add audio too in the video stream.
                if (self.mediapath == 'sfu') {
                    // if video was not enabled, do not include video.
                    if (!self.videoEnabled) {
                        media.videoSend = false;

                        // If set 'removeVideo' flag, then video track will be removed from peer connection when user turns off webcam
                        // Without this video track will be in 'muted' state in peer connection.
                        //media.removeVideo = true;

                        delete media.replaceVideo;
                        delete media.video;
                    }

                    media.audioSend = !is_screen || self.fileplay;
                    media.audioRecv = !is_screen;

                    if (!is_screen) {
                        var audioDevice1 = storageService.get('audio-device');
                        if (audioDevice1) {
                            media.audio = {
                                deviceId: self.getConstraintDeviceId(audioDevice1)
                            };
                            self.selectedAudioInput = audioDevice1;
                        }
                    }

                    if (!avDeviceService.getDevicePermissions().videoAllowed) {
                        media.videoSend = false;
                    } else if (avDeviceService.getSfuDeviceErrorFromId(storageService.get('video-device'))) {
                        media.videoSend = false;
                    }

                    if (!is_screen && !avDeviceService.getDevicePermissions().audioAllowed) {
                        media.audioSend = false;
                    } else if (avDeviceService.getSfuDeviceErrorFromId(storageService.get('audio-device'))) {
                        media.audioSend = false;
                    }
                }
            } else {
                if (type == 'audio-change') {
                    media = {
                        replaceAudio: true,
                        audioSend: !is_screen || self.fileplay,
                        audioRecv: !is_screen,
                        videoSend: false,
                        videoRecv: false
                    };
                } else {
                    // videoSend is used only for video stream not screen, and
                    // to avoid no m= line error, videoRecv is used for screen.
                    media = {
                        audioSend: !is_screen || self.fileplay,
                        audioRecv: !is_screen,
                        videoSend: true,
                        videoRecv: false
                    };
                    if (!is_screen) {
                        media.useCamera = false; // use fake video track instead of camera.
                    }
                }

                if (!is_screen) {
                    var audioDevice = storageService.get('audio-device');
                    if (audioDevice) {
                        media.audio = {
                            deviceId: self.getConstraintDeviceId(audioDevice)
                        };
                        self.selectedAudioInput = audioDevice;
                    }

                    if (self.audioStereo) {
                        if (typeof media.audio !== 'object') {
                            media.audio = {};
                        }
                        media.audio.channelCount = 2;
                        media.audio.echoCancellation = false;
                    }

                    if (self.videoFromMcu) {
                        media.videoRecv = true;
                    }
                }

                if (!avDeviceService.getDevicePermissions().videoAllowed) {
                    media.videoSend = false;
                } else if (avDeviceService.getSfuDeviceErrorFromId(storageService.get('video-device'))) {
                    media.videoSend = false;
                }

                if (!is_screen && !avDeviceService.getDevicePermissions().audioAllowed) {
                    media.audioSend = false;
                } else if (avDeviceService.getSfuDeviceErrorFromId(storageService.get('audio-device'))) {
                    media.audioSend = false;
                }
            }

            logService.log(
                'videoroomCtrl getMediaConstraints(' + type + ',' + !!is_screen + ') => ' + JSON.stringify(media)
            );
            return media;
        }

        // crossbrowser compatibility check.
        // safari throws OverConstrainedError with invalid constraints if exact is used. https://bugs.webkit.org/show_bug.cgi?id=187933
        function getConstraintDeviceId(id) {
            return helperService.isSafari() ? id : { exact: id };
        }

        function onStartVirtualBackgroundStream(ev, data) {
            videoFilterService.onStartVirtualBackgroundStream(data, self.getMediaConstraints);
        }

        function onStopVirtualBackgroundStream(ev, data) {
            videoFilterService.onStopVirtualBackgroundStream(data);
        }

        // after change in any attribute that could result in change in webcam constraints, call this function.
        function reapplyPublishConstraints() {
            if (self.useSimulcast2 && self.useSimulcast2 != 'legacy' && self.simulcastFlag) {
                try {
                    self.reapplySimulcastEncodings();
                } catch (error) {
                    logger.error('reapplyPublishConstraints', 'exception in apply sender parameters', error);
                }
                return;
            }

            var track = self.mystream && self.mystream.getVideoTracks()[0];
            if (track) {
                // apply if video is publishing.
                var resolution = self.getMaxVideoResolution();
                var frameRate = self.getMaxFrameRate();

                var constraints = track.getConstraints() || {};
                var constraintsLowered = false;
                var changed = false; // changed width or height.
                if (!constraints.width || !constraints.height) {
                    changed = true;
                    constraints = { width: resolution.width, height: resolution.height };
                } else {
                    if (typeof constraints.width === 'object') {
                        if (!changed && resolution.width != constraints.width.max) {
                            changed = true;
                            if (resolution.width < constraints.width.max) {
                                constraintsLowered = true;
                            }
                        }
                        constraints.width.max = constraints.width.ideal = resolution.width;
                        constraints.width.min = 320;
                    } else {
                        if (!changed && resolution.width != constraints.width) {
                            changed = true;
                        }
                        constraints.width = resolution.width;
                    }
                    if (typeof constraints.height === 'object') {
                        if (!changed && resolution.height != constraints.height.max) {
                            changed = true;
                        }
                        constraints.height.max = constraints.height.ideal = resolution.height;
                        constraints.height.min = 180;
                    } else {
                        if (!changed && resolution.height != constraints.height) {
                            changed = true;
                        }
                        constraints.height = resolution.height;
                    }
                }

                var changedRate = false; // changed frame rate.
                if (typeof constraints.frameRate === 'object') {
                    if (frameRate != constraints.frameRate.max) {
                        changedRate = true;
                    }
                    constraints.frameRate.max = constraints.frameRate.ideal = frameRate;
                    constraints.frameRate.min = Math.min(5, frameRate);
                } else {
                    if (frameRate != constraints.frameRate) {
                        changedRate = true;
                    }
                    constraints.frameRate = frameRate;
                }

                if (changedRate && self.bitrate && self.bitrate.adjust && self.bitrate.adjust.frameRate) {
                    self.bitrate.adjust.frameRate = frameRate;
                }

                if (changed && helperService.isMac() && constraintsLowered) {
                    // avoid zoom, by creating a clone, and deleting afterwards, if resolution is changed.
                    var track1 = track.clone();
                    $timeout(function () {
                        track1.stop();
                    }, 2000);
                }

                if (changed || changedRate) {
                    logService.log('videoroomCtrl - applying constraint ' + JSON.stringify(constraints));
                    self.msgflowEvent('apply-constraints', constraints);
                    track.applyConstraints(constraints).catch(function (err) {
                        logger.error('reapplyPublishConstraints', 'failed to apply publish constraint', constraints);
                    });
                }
            }
        }

        // value is optional. If present and non-zero, then that is used.
        // otherwise if frameRate was set, that is used.
        // otherwise uses other attributes to determine whether to return low
        // 15 or high 30 as default. Do not use videoLowOnLimit to reduce.
        function getMaxFrameRate(value) {
            return value || self.frameRate || ((self.videocodec == 'h264' || self.getIsVideoLow(true)) && 15) || 30;
        }

        // return the max resolution based on various attributes that control
        // the behavior. Do not use videocodec of h264.
        function getMaxVideoResolution() {
            if (self.useSimulcast2 && self.useSimulcast2 !== 'legacy' && self.simulcastFlag) {
                // lower values do not work currently, so make it fixed.
                return Object.assign({}, self.constraintsForSimulcast2); // return a copy.
            }

            let resolution = self.getVideoResolution(); // from settings.

            if (self.simulcastToggleState.restricted) {
                // lowered constraints in simulcast toggle state due to too many videos with content playing.
                Object.assign(resolution, self.simulcastToggleConfig.constraints);
            } else if (self.getIsVideoLow()) {
                const ratio = resolution.width / resolution.height;
                if (Math.abs(ratio - 16 / 9) < 0.0001 && (resolution.width > 640 || resolution.height > 360)) {
                    // treat as default ratio 16/9
                    resolution.width = 640;
                    resolution.height = 360;
                } else {
                    // scale larger side to 640 and smaller proportionally.
                    if (resolution.width >= resolution.height && resolution.width > 640) {
                        resolution.width = 640;
                        resolution.height = Math.round(resolution.width / ratio);
                    } else if (resolution.width < resolution.height && resolution.height > 640) {
                        resolution.height = 640;
                        resolution.width = Math.round(resolution.height * ratio);
                    }
                }
            }

            return resolution;
        }
    }
]);
